var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _g2, _path11, _g3, _path12, _g4, _path13, _g5, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWelcome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 193,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M294.268 179.047H25.891v13.954h268.377v-13.954z",
    fill: "#3A92E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.682 179.047H17.698v13.954h36.984v-13.954z",
    fill: "#A3C7F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M259.148 29.285H17.698v149.841h241.45V29.286z",
    fill: "#DEF0FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#welcome_svg__filter0_d_2614_24616)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.761 121.771H134.414c-16.951 0-30.739-13.791-30.739-30.747 0-16.955 13.788-30.747 30.739-30.747h169.347c16.951 0 30.739 13.792 30.739 30.747 0 16.956-13.788 30.747-30.739 30.747z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.614 117.633v23.04l23.845-20.606"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.244 43.24c1.298 1.866 1.947 3.976 1.866 6.247 0 .081.081.081.162.081.162-.324.325-.567.487-.892a8.949 8.949 0 00.162-7.22c-2.109-1.623-4.704-2.434-7.38-2.028-.082 0-.082.08 0 .162 1.865.649 3.487 1.947 4.703 3.65z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.735 49.082c-.974 2.109-2.596 3.894-4.623 4.949-.081.08-.081.162 0 .162.486 0 .973 0 1.46-.081a10.224 10.224 0 006.001-3.408 9.815 9.815 0 00-1.946-7.463c-.081-.081-.162 0-.162.08.405 1.948.08 3.895-.73 5.76zM33.595 43.16c2.108-.163 4.217.405 6.001 1.46.081.08.163 0 .081-.082-.162-.243-.324-.486-.405-.73a9.22 9.22 0 00-6.164-3.894 10.184 10.184 0 00-5.515 5.354c0 .081.08.163.08.081 1.704-1.216 3.813-2.028 5.922-2.19z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.815 55.167c-.567.081-1.054.163-1.622.163a9.924 9.924 0 01-5.434-1.623c-.08-.081-.162 0-.08.081.161.325.405.65.567.974 1.54 2.028 3.73 3.326 6.245 3.813 2.514-.974 4.46-2.921 5.515-5.355 0-.08-.081-.162-.081-.08-1.541 1.054-3.244 1.784-5.11 2.027z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.351 55.408c-1.378-1.866-2.108-4.137-1.946-6.409 0-.081-.081-.081-.162-.081-.162.243-.244.487-.406.73-1.054 2.272-1.135 4.949-.243 7.301 2.109 1.704 4.785 2.434 7.462 2.11.08 0 .08-.081 0-.162-1.866-.65-3.488-1.866-4.705-3.489z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.702 49.327c.892-2.11 2.515-3.813 4.542-4.868.081 0 .081-.162 0-.162h-.81c-2.515.243-4.867 1.46-6.408 3.407a10.047 10.047 0 001.865 7.545c.081.081.162 0 .162-.081-.405-1.947-.162-3.975.65-5.841z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M135.544 110.253c10.661 0 19.303-8.645 19.303-19.308 0-10.664-8.642-19.308-19.303-19.308-10.661 0-19.303 8.644-19.303 19.308 0 10.663 8.642 19.308 19.303 19.308zM245.847 81.368h-75.671a3.808 3.808 0 01-3.812-3.813 3.808 3.808 0 013.812-3.813h75.671a3.808 3.808 0 013.812 3.813 3.808 3.808 0 01-3.812 3.813zM228.896 96.458h-58.72a3.808 3.808 0 01-3.812-3.813 3.808 3.808 0 013.812-3.813h58.72a3.808 3.808 0 013.812 3.813c-.081 2.19-1.703 3.813-3.812 3.813z",
    fill: "#A3C7F0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M125.406 87.127l10.463 10.466 20.438-21.824",
    stroke: "#3074B7",
    strokeWidth: 5.84,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M41.704 159.331c22.755 0 41.202-18.451 41.202-41.212 0-22.761-18.447-41.213-41.202-41.213S.503 95.358.503 118.12s18.446 41.212 41.201 41.212z",
    fill: "#3A92E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "welcome_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 76,
    width: 83,
    height: 84
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.701 159.331c22.755 0 41.202-18.451 41.202-41.212 0-22.761-18.447-41.213-41.202-41.213S.5 95.358.5 118.12s18.447 41.212 41.201 41.212z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#welcome_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.632 87.532c-3.65-1.622-31.469-17.847-40.31-2.92-8.84 14.927-4.704 37.156-44.364 30.098",
    stroke: "#fff",
    strokeWidth: 1.168
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "welcome_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 76,
    width: 83,
    height: 84
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.701 159.331c22.755 0 41.202-18.451 41.202-41.212 0-22.761-18.447-41.213-41.202-41.213S.5 95.358.5 118.12s18.447 41.212 41.201 41.212z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#welcome_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.338 112.521c-3.65-1.622-20.763-43.484-40.471-10.059-8.76 14.927-30.496 62.062-44.365 30.098",
    stroke: "#fff",
    strokeWidth: 1.168
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "welcome_svg__c",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 76,
    width: 83,
    height: 84
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.701 159.331c22.755 0 41.202-18.451 41.202-41.212 0-22.761-18.447-41.213-41.202-41.213S.5 95.358.5 118.12s18.447 41.212 41.201 41.212z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#welcome_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.442 159.33c8.192-11.277 11.842-54.598-19.79-50.704-31.63 3.894-6.65 58.492-49.068 40.32",
    stroke: "#fff",
    strokeWidth: 1.168
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "welcome_svg__d",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 76,
    width: 83,
    height: 84
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.701 159.331c22.755 0 41.202-18.451 41.202-41.212 0-22.761-18.447-41.213-41.202-41.213S.5 95.358.5 118.12s18.447 41.212 41.201 41.212z",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#welcome_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.684 162.737c4.542-6.246 6.976-38.454-10.381-36.263-17.438 2.19-14.761 50.704-38.12 40.725",
    stroke: "#fff",
    strokeWidth: 1.168
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M88.584 20.93c5.778 0 10.462-4.685 10.462-10.465S94.362 0 88.584 0C82.805 0 78.12 4.685 78.12 10.465s4.684 10.466 10.463 10.466z",
    fill: "#3A92E5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M146.088 46.565a4.462 4.462 0 10-.002-8.924 4.462 4.462 0 00.002 8.924z",
    stroke: "#3A92E5",
    strokeWidth: 1.168,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M96.206 139.702l-6.812 3.894v-7.869l6.812 3.975z",
    fill: "#3A92E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "welcome_svg__filter0_d_2614_24616",
    x: 91.995,
    y: 48.597,
    width: 254.185,
    height: 103.755,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.84
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2614_24616"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2614_24616",
    result: "shape"
  })))));
}
export default SvgWelcome;